"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
const BaseMapConnector_1 = require("@becrop/components/Toolkit/Common/models/BaseMapConnector");
const BaseMap_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/BaseMap.vue"));
const axios_1 = __importDefault(require("axios"));
const AreaCertification_1 = __importDefault(require("@becrop/components/Rate/models/AreaCertification"));
const GraphCertificateRate_vue_1 = __importDefault(require("./components/GraphCertificateRate.vue"));
const MapAttributions_vue_1 = __importDefault(require("./components/MapAttributions.vue"));
const Legend_vue_1 = __importDefault(require("./components/Legend.vue"));
const ViewZeroCodes_vue_1 = __importDefault(require("./components/ViewZeroCodes.vue"));
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
const floating_vue_1 = require("floating-vue");
let RateCertificationViewMain = class RateCertificationViewMain extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.areaCertification = null;
        this.loadingActive = false;
        this.legend = false;
        this.errorPage = false; // Variable that controls if there is any type of error when loading the rate and if there is, activates the zero view.
        this.codeError = 0;
        // Map config
        this.fsactivemap = false;
        this.cropColor = '';
        this.cropBG = '';
        this.connector = new BaseMapConnector_1.BaseMapConnector(this.map_config);
        this.poligonos = [];
        // Info client
        this.name = ''; // name client
        this.ext = 0; // extension
        this.location = ''; // location area
        this.score = 0;
        this.categoryActive = '';
        this.loadingCertificate = false;
        this.colorController = new ColorLibController_1.default();
        this.mapStroke = '';
        this.mapBG = '';
    }
    created() {
        this.connector.reset();
        this.buildColor();
        this.startActive();
    }
    async mounted() {
        this.connector.randomizeMarkerPosition(false);
        this.startActive();
        this.loadingCertificate = true;
        await this.loadCertificate();
        this.loadingCertificate = false;
    }
    get isLightProvider() {
        const lightProviderKeys = ['OpenStreetMaps'];
        if (lightProviderKeys.includes(this.map_config.provider)) {
            return true;
        }
        return false;
    }
    colorArea(category) {
        this.categoryActive = category;
    }
    buildColor() {
        this.colorController.type = 'rate';
        this.mapStroke = this.colorController.getColor(this.categoryActive.toLowerCase());
        this.mapBG = this.colorController.getTransparency(this.categoryActive.toLowerCase());
        //console.log(this.categoryActive.toLowerCase());
    }
    async onChangeActive() {
        await this.connector.draw();
        await (0, sleep_1.default)(300);
        await this.drawParcelsAndSamples();
    }
    async drawParcelsAndSamples() {
        this.connector.reset();
        this.poligonos.forEach((polygon) => {
            this.connector.drawPolygon({
                color: this.mapStroke,
                shape: polygon,
                fill: this.mapBG,
            });
        });
        this.connector.center();
    }
    async startActive() {
        await (0, sleep_1.default)(100);
        await this.onChangeActive();
    }
    onFullscreenChange(fullscreen) {
        this.fsactivemap = fullscreen;
    }
    async loadCertificate() {
        try {
            const response = (await axios_1.default.get('/rate/api/certificate/' + this.token))
                .data;
            this.areaCertification = new AreaCertification_1.default(await response);
            this.colorArea(this.areaCertification.class);
            this.buildColor();
            this.poligonos.push(this.areaCertification.areas);
            this.name = this.areaCertification.client_name;
            this.ext = this.areaCertification.extension;
            this.location = this.areaCertification.location_text;
            this.score = this.areaCertification.score;
            this.errorPage = false;
            this.connector.reset();
            this.buildColor();
            this.startActive();
        }
        catch (error) {
            this.errorPage = true;
            this.codeError = error.response.status;
            console.log(error);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
    // eslint-disable-next-line camelcase
], RateCertificationViewMain.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String })
], RateCertificationViewMain.prototype, "token", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('active')
], RateCertificationViewMain.prototype, "onChangeActive", null);
RateCertificationViewMain = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            GraphCertificateRate: GraphCertificateRate_vue_1.default,
            MapAttributions: MapAttributions_vue_1.default,
            BaseMap: BaseMap_vue_1.default,
            Legend: Legend_vue_1.default,
            Info: lucide_vue_next_1.Info,
            ViewZeroCodes: ViewZeroCodes_vue_1.default,
            Loader: Loader_vue_1.default,
            Dropdown: floating_vue_1.Dropdown,
        },
    })
], RateCertificationViewMain);
exports.default = RateCertificationViewMain;
